<template>
  <div class="product-info-wrapper">
    <div class="banner">
      <div class="cover cover-byjsfwq">
        <div class="cover-text">
          <h4>边缘计算服务器</h4>
          <p class="info">QJ-E8系列智能城市微场景计算服务器是立足于智能硬件集成技术，将物联网安全、智能算力IT基础设施完善融合，提供智能社区应用需求的设备。是全景智联以社区场景细腻的“难点”、“痛点”、“堵点”为导向，细节、深入服务所推出的模拟边缘计算设备。</p>
          <ul>
            <li>2U2路机架构服务器</li>
            <li>20*3.5''或31*2.5''本地保存资源</li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 产品特点 -->
    <div class="product-features">
      <div class="common-title">
        <div class="common-title-content">
          产品特点
        </div>
      </div>
      <div class="product-feature-list">
        <div class="item" v-for="(item, index) in features" :key="index">
          <img :src="item.imgUrl" />
          <div class="text">{{ item.text }}</div>
        </div>
      </div>
    </div>
    <!-- 产品功能 -->
    <div class="product-function">
      <div class="common-title">
        <div class="common-title-content">
          产品功能
        </div>
      </div>
      <div class="product-function-list">
        <div class="item" v-for="(item, index) in funcList" :key="index">
          <img :src="item.imgUrl" />
          <div class="text">{{ item.text }}</div>
        </div>
      </div>
    </div>
    <!-- 产品优势 -->
    <div class="product-advantage">
      <div class="common-title">
        <div class="common-title-content">
          产品优势
        </div>
      </div>
      <div class="content">
        <div class="circle">
          <div class="badge">
            <img src="@/assets/images/productInfo/byjsfwq/badge.png" />
          </div>
          <div class="feature feature-one">
            <div class="text">性能强劲，配置便携</div>
          </div>
          <div class="feature feature-two">
            <div class="text">智慧节能，能效优化</div>
          </div>
          <div class="feature feature-three">
            <div class="text">一人算力，打通壁垒</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 应用场景 -->
    <div class="product-application-scene">
      <div class="common-title">
        <div class="common-title-content">
          应用场景
        </div>
      </div>
      <div class="product-scene-list">
        <div class="item" v-for="(item, index) in sceneList" :key="index">
          <img :src="item.imgUrl" />
          <div class="text" v-html="item.text"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "byjsfwq",
  data() {
    return {
      features: [
        {
          imgUrl: require("@/assets/images/productInfo/byjsfwq/yyzh.png"),
          text: "智能应用整合解决难点痛点"
        },
        {
          imgUrl: require("@/assets/images/productInfo/byjsfwq/sjbh.png"),
          text: "本地数据保护确保数据安全"
        },
        {
          imgUrl: require("@/assets/images/productInfo/byjsfwq/ssjs.png"),
          text: "就近实时计算提升响应速度"
        },
        {
          imgUrl: require("@/assets/images/productInfo/byjsfwq/csys.png"),
          text: "避免长时传输降低传输成本"
        }
      ],
      funcList: [
        {
          imgUrl: require("@/assets/images/productInfo/byjsfwq/ico_sjjr.png"),
          text: "数据接入"
        },
        {
          imgUrl: require("@/assets/images/productInfo/byjsfwq/ico_sjhj.png"),
          text: "数据汇聚"
        },
        {
          imgUrl: require("@/assets/images/productInfo/byjsfwq/ico_sjfx.png"),
          text: "数据分析"
        },
        {
          imgUrl: require("@/assets/images/productInfo/byjsfwq/ico_sjbc.png"),
          text: "数据保存"
        },
        {
          imgUrl: require("@/assets/images/productInfo/byjsfwq/ico_sjzs.png"),
          text: "数据展示"
        }
      ],
      sceneList: [
        {
          imgUrl: require("@/assets/images/productInfo/byjsfwq/zhaf.png"),
          text: "智慧安防"
        },
        {
          imgUrl: require("@/assets/images/productInfo/byjsfwq/zhtc.png"),
          text: "智慧停车"
        },
        {
          imgUrl: require("@/assets/images/productInfo/byjsfwq/rlsb.png"),
          text: "人脸识别"
        },
        {
          imgUrl: require("@/assets/images/productInfo/byjsfwq/zhjk.png"),
          text: "智慧监控"
        }
      ]
    };
  }
};
</script>
